export default "__VITE_ASSET__c661d9e3__"